import { versionCollection } from "@/firebase";

const state = {
  latestVersion: {},
};

const getters = {};

const actions = {
  getLatestVersion({ commit }) {
    return new Promise((resolve, reject) => {
      versionCollection
        .doc("qZdl8GQML8YeOqDOGe30")
        .get()
        .then((querySnapshot) => {
          resolve(commit("getLatestVersion", querySnapshot.data()));
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
};

const mutations = {
  getLatestVersion(state, payload) {
    state.latestVersion = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
